<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p style="text-align: center;">I would like to express my deepest gratitude to my Uncle Bob, whose unwavering support, infectious enthusiasm, and endless encouragement were instrumental in bringing <em>The Quest - Lucie no Legs</em> to life.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch003.vue?49807cc9